import { createContext } from 'react'

export const BreadcrumbContext = createContext({
  lastSectionName: null,
  setLastSectionName: (name: string | null) => {},
})
